<template>
<section>

    <section class="showroom_consultant partners" v-for="(news, mapId) in newsItemsGroupByBrand" :key="`${mapId}`">
        <div class="wrap">
            <h2 class="section_title"><p><img :src="news[0].brandUrl">{{news[0].brandName}}</p></h2>
        </div>

        <swiper
            class="swiper showroom_consultant_ul mh11"
            :options="swiperOption"
        >
            <swiper-slide class="item" 
                v-for="(newItem) in news" 
                :key="`${newItem.id}`"
            >
                <a class="carousel-shadow" @click="$router.push(`/newsInfo/${newItem.id}`)">
                    <figure>
                        <img :src="newItem.boardUrl">
                    </figure>
                    <figcaption class="news_figcaption">
                        <dl class="news_dl">
                            <dt>
                                {{newItem.title}}
                            </dt>
                            <dd>{{newItem.startDt}}</dd>
                        </dl>
                    </figcaption>
                </a>  
            </swiper-slide>
        </swiper>
    </section>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { DateFormatMixin } from '../../mixins/DateFormatMixin';

export default {
    name:'NewsList',
    mixins:[DateFormatMixin],
    computed: {
        ...mapState({
            boardItems : state => state.board.items,
            NEWS_DTYPE_MAIN: state => state.codeDictionary.items.BOARD_DTYPE.NEWS.id
        }),
        newsItemsGroupByBrand()
        {
            return this.boardItems.reduce((acc, curr) => {
                if(!acc[curr.brandId]) acc[curr.brandId] = []; 
                acc[curr.brandId].push(curr);
                return acc;
            },{});
        },
    },
    async created () {
        this.$store.state.headerTitle = '파트너스 컨텐츠';
        await this.getItems();
        this.$store.commit('SHOW_ONLOAD');
    },

    data() {
        return {
            filters: {...this.$store.state.board.filters},
            swiperOption: {
                autoHeight: true, //enable auto height
                slidesPerView: 1.4,
            },
        }
    },

    methods: {
        getItems(){
            let today = this.dayjsFormat(this.getToday() , 'YYYY-MM-DD');
            this.$store.dispatch("GET_BOARD_LIST", { 
                type:this.NEWS_DTYPE_MAIN, 
                showDt: today
            });
        }
    }
}
</script>
<style lang="scss" scoped>
</style>